import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { LanguageProvider } from './providers/LanguageProvider'
import App from './App.tsx'
import { applyTheme } from './config/theme'
import './index.css'

applyTheme('neon-tech')

if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual'
window.scrollTo({ top: 0, left: 0, behavior: 'auto' })

const prefetchAdmin = () => {
  void import('./pages/AdminPage')
  void import('./components/admin/AdminProducts')
  void import('./components/admin/AdminCommandPalette')
}
const prefetchOverlays = () => {
  void import('./components/features/ChatWidget')
  void import('./components/features/WhatsAppModal')
  void import('./components/features/AppDownloadModal')
  void import('./components/features/PromoPopup')
  void import('./components/features/NotificationOptIn')
  void import('./components/features/AccountPromptModal')
}
window.addEventListener('load', () => {
  const idle = (window as { requestIdleCallback?: (cb: () => void, options?: { timeout: number }) => void }).requestIdleCallback
  const run = idle ? () => idle(prefetchAdmin, { timeout: 3000 }) : () => window.setTimeout(prefetchAdmin, 2000)
  run()
  window.setTimeout(prefetchOverlays, 1000)
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter><LanguageProvider><App /></LanguageProvider></BrowserRouter>
  </React.StrictMode>,
)
